var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blog-progress-bar"},[_c('div',{staticClass:"blog-progress-bar__total"}),_c('div',{staticClass:"blog-progress-bar__progress",style:(_vm.progressWidth)})])}
var staticRenderFns = []

export { render, staticRenderFns }